import React from 'react';
import i18n from '../../../../i18n';
import { SideBar } from '../../sidebar';
import Select from 'react-select';
import { getWalletUsers } from '../../../../models/users';
import Dropdown from '../../../common/DropDown';
import { selectStyles } from '../../../../styles/components/js/selectStyle';
import NoData from '../../../common/NoData';
import { TableSkeleton } from '../../../common/skelton/TableSkelton';
import { Download, Printer, FileSpreadsheet, ArrowLeft, FileMinus } from 'lucide-react';
import FilterSection from '../../../common/Filter';
import { tableStyles } from '../../../../styles/components/js/tableStyle';
import DataTable from 'react-data-table-component';
import { getLoggedUser } from '../../../../state/user';
import { getWalletTransactions } from './services/WalletTransactionServices';
import NewDropdown from '../../../common/NewDropDown';
import StatusBadge from '../../../common/StatusBadge';
import { TEST_WALLET_STATUS, TRANSACTION_STATUS } from '../../../../constants/status';
import { ActionModal } from './components/ActionModal';
import { withRouter } from '../../../../hoc/withRouter';
import { apiUrl, imageUrl } from '../../../../constants/global';
import { downloadFile } from '../../../../utils/downloadFile';
import { WarningBox } from '../../../common/WarningBox';
import { ConfirmationModal } from './components/ConfirmationModal';
import HeaderBanner from '../../../common/HeaderBanner';
import { formatDate } from '../../../../utils/common';
import '../../../../styles/components/receipt-details-table.scss';

const user = getLoggedUser();

class AuctionPaymentDetails extends React.Component {
  constructor() {
    super();
    this.state = {
      search: {
        startDate: null,
        endDate: null,
        payment: '',
        bidder: null,
      },
      status: null,
      groupId: null,
      type: 'client_payment',
      input: {},
      customers: [],
      auctionPayments: [],
      selectedIds: [],
      selectedSum: 0,
      isLoading: false,
      limit: 15,
      page: 1,
      showConfirm: false,
      showAction: false,
      exportLoading: false,
      selectedRow: null,
      confirmAction: null,
    };

    this.handleSearchChange = this.handleSearchChange.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    const { groupId } = this.props.params;
    // Parse URL query params
    const params = new URLSearchParams(window.location.search);
    const search = {
      startDate: params.get('startDate') || null,
      endDate: params.get('endDate') || null,
      payment: params.get('payment') || '',
      bidder: params.get('bidder') || null,
    };
    const status = params.get('status') || 'pending';
    const page = parseInt(params.get('page')) || 1;
    const limit = parseInt(params.get('limit')) || 15;

    this.setState({ groupId, search, status, page, limit }, () => {
      this.getBidders();
      this.getAuctionPayments();
    });
  }

  // Update URL without refreshing page
  updateUrlQuery(q) {
    const queryString = new URLSearchParams(
      Object.fromEntries(Object.entries(q).filter(([_, v]) => v !== '' && v !== null))
    ).toString();
    window.history.replaceState(null, '', `${window.location.pathname}?${queryString}`);
  }
  async getAuctionPayments() {
    this.setState({ isLoading: true });
    let { limit, page, status, groupId, type } = this.state;
    let { startDate, endDate, payment, bidder } = this.state.search;
    if (!status) {
      return;
    }
    const q = {
      page: page,
      limit: limit,
    };
    if (startDate) q.startDate = startDate;
    if (endDate) q.endDate = endDate;
    if (payment) q.payment = payment;
    if (status) q.status = status;
    if (bidder) q.bidder = bidder;

    // Update URL
    this.updateUrlQuery(q);

    let response = await getWalletTransactions({ ...q, group: groupId, type });
    if (response.success) {
      let auctionPayments = response.data;
      let { total } = response.meta;
      this.setState({
        auctionPayments,
        total,
        isLoading: false,
      });
    }
    this.setState({ isLoading: false });
  }

  async getBidders() {
    this.setState({ bidderLoading: true });
    const response = await getWalletUsers();
    let data = response.data;
    if (response.success) {
      const customers = data.map((item) => {
        return {
          value: item.id,
          label: item.name + ' (' + item.username + ')',
        };
      });

      this.setState({ bidderLoading: false, customers });
    } else {
      this.setState({ bidderLoading: false });
    }
  }

  getColumns = () => {
    const { auctionPayments, selectedIds, status } = this.state;
    let columns = [
      {
        id: 'select',
        name:
          (status === 'pending' && user.role === 'F') ||
          (status === 'fs_approved' && user.role === 'F') ? (
            <input
              type="checkbox"
              checked={
                auctionPayments.length > 0 &&
                selectedIds.length > 0 &&
                selectedIds.length === auctionPayments.length
              }
              onChange={() => this.handleCheckAll(auctionPayments)}
              aria-label="Select all eligible rows"
            />
          ) : null,
        cell: (row) =>
          (status === 'pending' && user.role === 'F') ||
          (status === 'fs_approved' && user.role === 'F') ? (
            <input
              type="checkbox"
              checked={selectedIds.includes(row.id)}
              onChange={() => this.handleCheckboxChange(row)}
              aria-label={`Select row ${row.id}`}
            />
          ) : null,
        width: '50px',
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
      {
        id: 1,
        name: 'Sl No',
        width: '70px',
        sortable: false,
        center: true,
        cell: (row, i) => i + 1,
      },
      {
        id: 2,
        name: 'ID',
        width: '80px',
        sortable: true,
        center: true,
        cell: (row) => row.id,
      },
      {
        id: 3,
        name: i18n.t('mzad_id'),
        minWidth: '120px',
        cell: (row) => `Mzad ${row.auction}`,
      },
      {
        id: 4,
        name: i18n.t('auction_name'),
        minWidth: '140px',
        cell: (row) => `Mzad ${row.title}`,
      },
      {
        id: 5,
        name: i18n.t('group_name'),
        minWidth: '140px',
        cell: (row) => row.group_name,
        wrap: true,
      },
      {
        id: 6,
        name: i18n.t('username'),
        minWidth: '140px',
        cell: (row) => row.username,
        wrap: true,
      },
      {
        id: 7,
        name: i18n.t('email'),
        minWidth: '130px',
        cell: (row) => row.email,
        wrap: true,
      },
      {
        id: 8,
        name: i18n.t('total_payable'),
        width: '140px',
        right: true,
        cell: (row) => row.auction_total,
      },
      {
        id: 9,
        name: i18n.t('bidder_paid'),
        width: '140px',
        right: true,
        cell: (row) => row.auction_paid,
      },
      {
        id: 10,
        name: i18n.t('payable_balance'),
        width: '150px',
        right: true,
        cell: (row) => <span className="highlight-table-value">{row.auction_balance}</span>,
      },
      {
        id: 11,
        name: i18n.t('deposite'),
        width: '120px',
        right: true,
        cell: (row) => <span className="highlight-table-value">{row.credit}</span>,
      },

      {
        id: 12,
        name: i18n.t('payment_type'),
        width: '140px',
        center: true,
        cell: (row) => row.method,
      },
      {
        id: 13,
        name: i18n.t('status'),
        width: '130px',
        center: true,
        cell: (row) => <StatusBadge status={TRANSACTION_STATUS[row.status]} />,
      },
      {
        id: 14,
        name: i18n.t('date'),
        width: '180px', // increase width to fit date + time
        center: true,
        cell: (row) => {
          if (!row?.created_at) return '-';
          const date = new Date(row.created_at);
          const day = String(date.getDate()).padStart(2, '0');
          const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
          const year = date.getFullYear();
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          return `${day}/${month}/${year} ${hours}:${minutes}`;
        },
      },

      {
        id: 16,
        name: i18n.t('action'),
        minWidth: '160px',
        center: true,
        cell: (row) => {
          const canShow =
            (row.status === 'B' && (user.role === 'FS' || user.role === 'F')) ||
            (row.status === 'FS' && user.role === 'FM');

          return canShow ? (
            <div className="action-buttons">
              <button
                className="button1 button1-primary button1-action"
                onClick={() => this.handleActions(row)}
              >
                {i18n.t('action')}
              </button>
            </div>
          ) : null;
        },
      },
    ];

    return columns;
  };

  handleSearchChange = (e) => {
    const { name, value } = e.target;

    this.setState((prevState) => {
      const updatedSearch = { ...prevState.search, [name]: value };
      return { search: updatedSearch };
    });
  };

  handleSearch = () => {
    this.getAuctionPayments();
  };

  handleClear = () => {
    const defaultSearch = {
      startDate: null,
      endDate: null,
      payment: '',
      bidder: null,
    };

    this.setState({ search: defaultSearch, page: 1 }, () => {
      this.updateUrlQuery({ page: 1, limit: this.state.limit });
      this.getAuctionPayments();
    });
  };

  onChangePage = (page) => {
    this.setState({ page: page }, () => {
      this.getAuctionPayments();
    });
  };

  onChangeRowsPerPage = (limit) => {
    this.setState({ limit: limit, page: 1 }, () => {
      this.getAuctionPayments();
    });
  };

  handleActions = (row) => {
    this.setState({
      showAction: true,
      selectedRow: row,
    });
  };

  handleConfirmation = (type) => {
    this.setState({
      showConfirm: true,
      confirmAction: type,
    });
  };

  handleDownload = async (fileType) => {
    this.setState({ exportLoading: true });
    try {
      await downloadFile({
        url: `${apiUrl}v2/report/wallet`,
        params: {
          status: TEST_WALLET_STATUS[this.state.status],
          type: this.state.type,
          groupId: this.state.groupId,
          fileType,
        },
        token: user.token,
        fileType,
        fileName: 'Auction_Transaction',
      });
    } finally {
      this.setState({ exportLoading: false });
    }
  };

  handleCheckboxChange = (row) => {
    this.setState((prev) => {
      const selectedIds = prev.selectedIds.includes(row.id)
        ? prev.selectedIds.filter((id) => id !== row.id)
        : [...prev.selectedIds, row.id];

      const selectedSum = prev.auctionPayments
        .filter((p) => selectedIds.includes(p.id))
        .reduce((sum, p) => sum + parseFloat(p.credit || 0), 0);

      return { selectedIds, selectedSum };
    });
  };

  handleCheckAll = (payments) => {
    this.setState((prev) => {
      const allSelected = prev.selectedIds.length === payments.length;
      const selectedIds = allSelected ? [] : payments.map((r) => r.id);
      const selectedSum = allSelected
        ? 0
        : payments.reduce((sum, p) => sum + parseFloat(p.credit || 0), 0);
      return { selectedIds, selectedSum };
    });
  };

  render() {
    const {
      customers,
      showConfirm,
      showAction,
      selectedRow,
      exportLoading,
      selectedIds,
      status,
      selectedSum,
      confirmAction,
    } = this.state;

    return (
      <React.Fragment>
        <HeaderBanner
          title={i18n.t('auction_payments_transaction')}
          // subtitle={i18n.t('track_your_successful_bid')}
        />
        <section className="dashboard-section">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? 'col-xl-12 col-lg-12 col-md-12'
                    : 'col-xl-9 col-lg-12 col-md-12'
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          });
                        }}
                      >
                        {this.state.hideSidebar && <i className="icon-size-actual"></i>}
                        {!this.state.hideSidebar && <i className="icon-size-fullscreen"></i>}
                      </span>
                    </div>
                    <div className="header-action">
                      {/* Back Button */}
                      <button
                        className="button1 button1-gradient button1-back"
                        onClick={() =>
                          this.props.navigate(`/auction-payment?status=${this.state.status}`)
                        }
                      >
                        <ArrowLeft size={18} className="icon" />
                        <span>Back</span>
                      </button>
                      <NewDropdown
                        label={i18n.t('export')}
                        loading={exportLoading}
                        icon={Download}
                        items={[
                          {
                            label: i18n.t('pdf'),
                            icon: Printer,
                            onClick: () => this.handleDownload('pdf'),
                          },
                          {
                            label: i18n.t('excel'),
                            icon: FileSpreadsheet,
                            onClick: () => this.handleDownload('excel'),
                          },
                        ]}
                      />
                    </div>
                  </div>
                  <div className="card-body">
                    <FilterSection
                      loading={this.state.isLoading}
                      onSearch={this.handleSearch}
                      onClear={this.handleClear}
                    >
                      {/* Start Date */}
                      <div className="select-wrapper floating-label-wrapper">
                        <input
                          id="startDate"
                          type="date"
                          name="startDate"
                          value={this.state.search.startDate || ''}
                          onChange={this.handleSearchChange}
                          className="filter-base floating-input"
                          placeholder=" " // Important: single space for floating effect
                        />
                        <label htmlFor="startDate" className="floating-label">
                          {i18n.t('start_date')}
                        </label>
                      </div>

                      {/* End Date */}
                      <div className="select-wrapper floating-label-wrapper">
                        <input
                          id="endDate"
                          type="date"
                          name="endDate"
                          value={this.state.search.endDate || ''}
                          onChange={this.handleSearchChange}
                          className="filter-base floating-input"
                          placeholder={i18n.t('end_date')}
                        />
                        <label htmlFor="endDate" className="floating-label">
                          {i18n.t('end_date')}
                        </label>
                      </div>

                      {/* Payment Type Dropdown */}
                      <Dropdown
                        name="payment"
                        value={this.state.search.payment}
                        onChange={this.handleSearchChange}
                        placeholder={i18n.t('payment')}
                        empty={i18n.t('select_payment')}
                        options={[
                          { value: 'online', label: i18n.t('online') },
                          { value: 'offline', label: i18n.t('offline') },
                          { value: 'wallet', label: i18n.t('wallet') },
                        ]}
                      />

                      {/* Bider Dropdown */}
                      <div className="react-select-wrapper">
                        <Select
                          options={customers}
                          value={
                            customers.find((c) => c.value === this.state.search.bidder) || null
                          }
                          onChange={(selectedOption) => {
                            this.setState((prevState) => ({
                              search: {
                                ...prevState.search,
                                bidder: selectedOption ? selectedOption.value : null,
                              },
                            }));
                          }}
                          name="bidder"
                          styles={selectStyles}
                          menuPlacement="auto"
                          menuPortalTarget={document.body}
                          placeholder={i18n.t('search_bidder')}
                          className=""
                        />
                        {/* Only show label when there's a selected value */}

                        <label className="react-select-label">{i18n.t('bidder')}</label>
                      </div>
                    </FilterSection>

                    <div
                      className={`warning-box-wrapper ${
                        status === 'pending' && selectedIds.length > 0 ? 'open' : 'exit'
                      }`}
                    >
                      <WarningBox
                        message="Auction payment approval warning. Please confirm your action."
                        onApprove={() => this.handleConfirmation('approve')}
                        onReject={() => this.handleConfirmation('reject')}
                      />
                    </div>

                    <div className="Data-Listing">
                      {this.state.isLoading ? (
                        <TableSkeleton columns={6} rows={10} />
                      ) : this.state.auctionPayments.length ? (
                        <DataTable
                          responsive={true}
                          columns={this.getColumns()}
                          data={this.state.auctionPayments}
                          customStyles={tableStyles}
                          highlightOnHover
                          pagination
                          paginationServer
                          paginationTotalRows={this.state.total}
                          paginationPerPage={this.state.limit}
                          paginationDefaultPage={this.state.page}
                          paginationRowsPerPageOptions={[15, 25, 50, 100]}
                          paginationComponentOptions={{
                            rowsPerPageText: i18n.t('rows_per_page'),
                            rangeSeparatorText: i18n.t('out'),
                          }}
                          onChangePage={this.onChangePage}
                          onChangeRowsPerPage={this.onChangeRowsPerPage}
                          expandableRows
                          expandableRowsComponent={({ data }) => (
                            <PaymentReceiptTable data={data.payment_receipts} />
                          )}
                        />
                      ) : (
                        <NoData
                          message="No Auction Payments available"
                          actionText={i18n.t('refresh')}
                          onAction={this.getAuctionPayments.bind(this)}
                          s
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <ActionModal
          show={showAction}
          selectedPayment={selectedRow}
          onClose={() => this.setState({ showAction: false })}
          onComplete={() => {
            this.getAuctionPayments();
            this.setState({ showAction: false, selectedRow: null });
          }}
        />
        <ConfirmationModal
          show={showConfirm}
          selectedIds={selectedIds}
          selectedSum={selectedSum}
          confirmAction={confirmAction}
          onClose={() =>
            this.setState({
              showConfirm: false,
              selectedIds: [],
              selectedSum: 0,
              confirmAction: null,
            })
          }
          onComplete={() => {
            this.getAuctionPayments();
            this.setState({
              showConfirm: false,
              selectedIds: [],
              selectedSum: 0,
              confirmAction: null,
            });
          }}
        />
      </React.Fragment>
    );
  }
}
export default withRouter(AuctionPaymentDetails);

const PaymentReceiptTable = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="no-bidders">
        <div className="no-bidders-content">
          <span className="no-bidders-icon">
            <FileMinus />
          </span>
          <span>No Receipt available</span>
        </div>
      </div>
    );
  }

  return (
    <div className="receipts-wrapper">
      <div className="receipts-header">
        <h6>Receipt Information</h6>
        <span className="receipts-count">
          {data.length} Receipt{data.length !== 1 ? 's' : ''}
        </span>
      </div>

      <div className="receipts-table-container">
        <table className="receipts-table">
          <thead>
            <tr>
              <th>Receipt Id</th>
              <th>Receipt Amount</th>
              <th>Receipt Number</th>
              <th>Payment Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {data.map((receipt) => (
              <tr key={receipt.id}>
                <td className="receipts-email">{receipt.id}</td>
                <td className="receipts-email">{receipt.amount}</td>
                <td className="receipts-number">{receipt.receipt_number}</td>
                <td className="receipts-number">{formatDate(receipt.created_at)}</td>
                <td className="receipts-number">
                  <a
                    href={`${imageUrl}uploads/wallet/receipt/${receipt.receipt_url}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="receipt-link"
                  >
                    {i18n.t('view')}
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
